


































































import {
  ref,
  defineComponent,
  toRefs,
  reactive,
  inject,
} from '@vue/composition-api'

import { editMediaItemOccurence } from '@/shared/api'
import CloseButton from '@/components/custom/CloseButton.vue'
import { License } from '@/shared/types'
import { licensesSymbol } from '@/shared/state-management/symbols'

export default defineComponent({
  name: 'EditMediaItemOccurence',
  components: {
    CloseButton,
  },
  props: {
    textbook: Object,
    textbookIssue: Object,
    mediaItemOccurence: Object,
  },
  setup(props, { emit }) {
    const EditMediaItemOccurenceForm = ref(null)
    const data = reactive({
      valid: true,
      licenses: props.mediaItemOccurence.licenses
        ? props.mediaItemOccurence.licenses
        : ([] as Array<License>),
      isDownloadable: props.mediaItemOccurence.isDownloadable,
    })

    const loadingData = ref(false)
    const availableLicenses = inject(licensesSymbol) as { value: Array<string> }

    const submit = async () => {
      const form = EditMediaItemOccurenceForm.value
      form.validate()
      const postData = {
        licenseIds: data.licenses.map((license: License) => license.id),
        isDownloadable: data.isDownloadable,
      }
      loadingData.value = true
      try {
        const newMediaItemOccurence = await editMediaItemOccurence(
          props.textbookIssue.id,
          props.mediaItemOccurence.id,
          postData
        )
        emit('media-item-occurence-edited', newMediaItemOccurence)
        loadingData.value = false
      } catch (e) {
        loadingData.value = false
        throw e
      }
    }

    return {
      ...toRefs(data),
      loadingData,
      EditMediaItemOccurenceForm,
      availableLicenses,
      submit,
    }
  },
})
